import { render, staticRenderFns } from "./ProductsMenuComponent.vue?vue&type=template&id=2273f848&"
import script from "./ProductsMenuComponent.vue?vue&type=script&lang=js&"
export * from "./ProductsMenuComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports